<toaster-container></toaster-container>
<div class="row" style="width: 1200px">
  <div class="col-md-4">
    <h2 class="title">Forgot Password</h2>
    <small class="form-text sub-title">
      Please type in your email address to request a password-reset link
    </small>
    <form #form="ngForm" autocomplete="nope">
      <div *ngIf="errors && errors.length > 0 && !submitted"
           class="alert alert-danger" role="alert">
        <div><strong>Error</strong></div>
        <div *ngFor="let error of errors">{{ error }}</div>
      </div>

      <div class="form-group">
        <mat-form-field>
            <input matInput type="email" name="email" placeholder="Email" [(ngModel)]="user.username" id="input-email"  pattern=".+@.+\..+" #email="ngModel" [class.form-control-danger]="email.invalid && email.touched" autofocus
            [required]="getConfigValue('forms.validation.email.required')">
        </mat-form-field>
        <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">
          Email is invalid
        </small>
        <small class="form-text error"
               *ngIf="email.invalid && email.touched && email.errors?.pattern">
          Email is invalid
        </small>
      </div>

      <button mat-raised-button
        [disabled]="submitted || !form.valid || !user.username"
        color="primary"
        [class.btn-pulse]="submitted"
        (click)="requestToken()">
        Request
      </button>
    </form>

    <br>

    <p>
        Already have an account? <a routerLink="/auth/login" class="auth-link">Log In</a>
    </p>

  </div>

  <div class="col-md-8">

  </div>
</div>
